import React from 'react';

const About = () => {
  return (
    <section id="about">
      <h2>About Me</h2>
      <p style={{ lineHeight: '1.6', fontSize: '1.1rem', color: '#c9d1d9' }}>
        I am Himanshu Raj, a 3rd-year B.Tech Computer Science & Engineering student at Jagannath University, Jaipur. 
        My passion lies in Artificial Intelligence and Machine Learning, and I am motivated to build impactful solutions 
        that leverage data to solve real-world problems. Currently, I am enhancing my skills in Data Analytics using Power BI, 
        aiming to transform raw data into actionable intelligence.
      </p>
    </section>
  );
};

export default About;